module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-gedangsari.bcba9c6e.png";